import { Panel } from "../../../components/panels/Panel";
import "../../../styles/dior/digital_twin.scss";
import {
  CARTS, getCartColor, getFlattenPoolsList, POOL_TYPE_STEP,
  POOLS_GROUPS_LINE_1,
  POOLS_GROUPS_LINE_2
} from "../../../services/live-interface/dior-interface-service";
import { Fragment } from "react";

const DiorMiniProgressBar = ({ value, maxValue }) => {
  const percent = Math.floor(value / maxValue * 100, 100);
  return (
    <div className="w-full flex flex-col items-center gap-1">
      <div className="w-full bg-white/50 h-2 rounded-full overflow-hidden">
        <div className="h-full bg-white rounded-md" style={{ width: percent + '%'}}/>
      </div>
      <div className="text-xs">
        {/* TODO Format duration */}
        {Math.round(value)}/{Math.round(maxValue)}
      </div>
    </div>
  );
};

const DiorLine = ({ poolsGroups, currentData, cartsErrors }) => {
  const countWithTagId = currentData.filter(item => item.tag_id != null).length;
  // const validatedStepsCount = currentData.filter(item => item.is_validated).length;

  return (
    <div className="w-full bg-perception-black-500 flex flex-col h-[200px] gap-4 p-4 rounded-md overflow-x-auto">
      <div className="flex-none flex gap-4 fixed">
        <div className="bg-perception-blue rounded-md text-sm px-2 py-1 text-white">Occupied baths: {countWithTagId}/{currentData.length}</div>
        {/*<div className="bg-perception-blue rounded-md text-sm px-2 py-1 text-white">Etapes validées : {validatedStepsCount}/{currentData.length}</div>*/}
      </div>
      <div className="flex-1 flex gap-8 flex-nowrap min-w-max h-full mt-11 justify-start">
        {
          poolsGroups.map((poolGroup, poolGroupIndex) => (
            <div key={poolGroupIndex} className="flex-shrink-0 flex gap-2 h-full border-2 border-perception-black-800 p-2 rounded-md">
              {
                poolGroup.map((pool, poolIndex) => {
                  const poolLiveData = currentData?.[pool.id];
                  const tagId = poolLiveData?.tag_id;

                  const hasValue = poolLiveData?.value !== null && poolLiveData?.value >= 0;
                  const isError = cartsErrors[tagId]?.includes(pool.id);

                  const textColor = hasValue ? 'text-white' : 'text-perception-gray-600';
                  const bgColor = hasValue ? 'bg-perception-blue' : 'bg-perception-black-700';
                  const border = isError ? 'border-2 border-error' : '';

                  const cartColor = isError ? '#F9224B' : getCartColor(tagId, CARTS);

                  return (
                    <Fragment key={poolIndex}>
                      <div className={`w-16 flex-shrink-0 ${bgColor} ${border} text-white rounded-md flex justify-center items-center relative`}>
                        <div className={`text-xs absolute top-1 left-0 w-full text-center ${textColor}`}>
                          { pool.type === POOL_TYPE_STEP ? 'Treatment' : 'Cleaning' }
                        </div>
                        <div className="w-3/4 flex justify-center">
                          {
                            hasValue ?
                              <DiorMiniProgressBar value={poolLiveData.value} maxValue={pool.value}/>
                              :
                              <div className="flex justify-center items-center bg-perception-gray-700 size-5 text-xs rounded-full">{pool.id + 1}</div>
                          }
                        </div>
                        {
                          hasValue &&
                            <div className="flex gap-1 justify-center w-full p-1 absolute bottom-0 left-0">
                              <div className="rounded-full text-xs px-2 text-nowrap text-center" style={{ backgroundColor: cartColor}}>
                                Cart {tagId}
                              </div>
                            </div>
                        }
                      </div>
                    </Fragment>
                  )
                })
              }
            </div>
          ))
        }
      </div>
    </div>
  );
};

export const DiorDigitalTwin = ({ currentData, cartsErrors }) => {

  return (
    <Panel title="LINE OVERVIEW (DIGITAL TWIN)" width="w-3/5" className="rounded-md bg-grid">
      <div className="w-full h-full flex flex-col justify-around items-end">
        <DiorLine poolsGroups={POOLS_GROUPS_LINE_1} currentData={currentData} cartsErrors={cartsErrors} />
        <DiorLine poolsGroups={POOLS_GROUPS_LINE_2} currentData={currentData} cartsErrors={cartsErrors} />
      </div>
    </Panel>
  );
};